import CommonHeader from '@/components/feature/CommonHeader';
import FloatingCta from '@/components/feature/FloatingCta';
import MobileBottomNav from '@/components/feature/MobileBottomNav';
import SeoHead from '@/components/feature/SeoHead';
import MouthpieceHero from './components/MouthpieceHero';
import MouthpieceKeyMessage from './components/MouthpieceKeyMessage';
import MouthpieceComparison from './components/MouthpieceComparison';
import MouthpieceWhyWeCanJudge from './components/MouthpieceWhyWeCanJudge';
import MouthpieceCaseStudies from './components/MouthpieceCaseStudies';
import MouthpieceConcerns from './components/MouthpieceConcerns';
import MouthpieceReport from './components/MouthpieceReport';
import MouthpieceOutcome from './components/MouthpieceOutcome';
import MouthpieceFlow from './components/MouthpieceFlow';
import MouthpieceDoctor from './components/MouthpieceDoctor';
import MouthpieceFaq from './components/MouthpieceFaq';
import MouthpieceAccess from './components/MouthpieceAccess';
import MouthpieceCta from './components/MouthpieceCta';
import CommonFooter from '@/components/feature/CommonFooter';
import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const mouthpieceJsonLd = [
  {
    '@type': 'MedicalWebPage',
    '@id': `${siteUrl}/mouthpiece/`,
    url: `${siteUrl}/mouthpiece/`,
    name: 'マウスピース矯正相談｜moyuk SAPPORO 札幌｜判断するための矯正相談',
    description: '札幌中心部moyuk SAPPOROのマウスピース矯正相談ページ。治療の押しつけなし、納得するまで考えられる矯正相談。チカホ直結、土日対応。',
    inLanguage: 'ja',
    about: {
      '@type': 'MedicalProcedure',
      name: 'マウスピース矯正',
      procedureType: 'http://schema.org/NoninvasiveProcedure',
      bodyLocation: '歯・顎',
    },
    isPartOf: { '@id': `${siteUrl}/#website` },
  },
  {
    '@type': 'Service',
    name: 'マウスピース矯正相談',
    provider: {
      '@type': 'Dentist',
      name: 'moyuk SAPPORO',
      '@id': `${siteUrl}/#dentist`,
    },
    serviceType: 'マウスピース矯正',
    areaServed: {
      '@type': 'City',
      name: '札幌市',
    },
    description: '透明なマウスピースを使った目立たない歯科矯正。ワイヤー矯正との違いや適応ケースを丁寧に説明。無料診断で自分に合うか判断できます。',
  },
];

export default function MouthpiecePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="マウスピース矯正 無料診断レポート 札幌 | moyuk SAPPORO さいわいデンタル"
        description="札幌・moyuk SAPPOROのマウスピース矯正相談。初回無料で「あなた専用 矯正プラン比較レポート」を作成。治療法の向き不向き・費用・期間を比較して、自分で判断できる環境を提供します。完全個室・治療を急かしません。"
        keywords="マウスピース矯正 札幌,インビザライン 札幌,矯正 無料診断 札幌,歯科矯正 比較 札幌,矯正 セカンドオピニオン 札幌,moyuk SAPPORO,さいわいデンタル,チカホ 矯正"
        canonical={`${siteUrl}/mouthpiece/`}
        ogType="article"
        ogTitle="マウスピース矯正 無料診断レポート 札幌 | moyuk SAPPORO さいわいデンタル"
        ogDescription="「本当に自分に合う矯正方法を知りたい」という方へ。初回無料の診断データをもとに、あなた専用の矯正プラン比較レポートを作成します。治療を急かさない札幌の矯正歯科。"
        ogSiteName="moyuk SAPPORO さいわいデンタル"
        ogLocale="ja_JP"
        ogImageWidth="1200"
        ogImageHeight="630"
        twitterCard="summary_large_image"
        twitterTitle="マウスピース矯正 無料診断レポート 札幌 | moyuk SAPPORO"
        twitterDescription="初回無料。あなた専用の矯正プラン比較レポートを作成。治療を急かさない札幌の矯正歯科。チカホ直結のmoyuk SAPPOROにあります。"
        jsonLd={mouthpieceJsonLd}
      />
      <CommonHeader />
      <main className="pt-20">
        <MouthpieceHero />
        <MouthpieceKeyMessage />
        <MouthpieceComparison />
        <MouthpieceWhyWeCanJudge />
        <MouthpieceCaseStudies />
        <MouthpieceConcerns />
        <MouthpieceReport />
        <MouthpieceOutcome />
        <MouthpieceFlow />
        <MouthpieceDoctor />
        <MouthpieceFaq />
        <MouthpieceAccess />
        <MouthpieceCta />
      </main>
      <CommonFooter />
      <FloatingCta href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb" label="無料診断を予約する" />
      <MobileBottomNav />
    </div>
  );
}
